import { useParams } from 'react-router-dom';
import { useState, useEffect } from "react";
import {
    Box,
    Container,
    Tabs,
    Tab,
    Typography,
} from '@mui/material';

import Header from "../headers/Header";
import PlayerCourses from '../dataDisplay/stats/player/PlayerCourses';
import PlayerOverview from '../dataDisplay/stats/player/PlayerOverview';
import StatsPlayerHeader from "../dataDisplay/StatsPlayerHeader";
import SearchBar from '../utilComponents/SearchBar';
import LoadingShells from '../utilComponents/LoadingShells';
import EloChart from '../dataDisplay/stats/player/EloChart';
import APNCourseChart from '../dataDisplay/stats/player/APNCourseChart';
import { fetchWithRetry } from '../utils/ApiHelper'
import { useRoster } from '../utils/useRoster';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;

const StatsPlayer = () => {
    const params = useParams();

    const [playerData, setPlayerData] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0);
    const [loading, setLoading] = useState(true); // State for loading spinner

    const { roster } = useRoster();
    const playerInfo = roster?.find(player => player.playerId === params.id);
    
    // Get data 
    useEffect(() => {
        const getPlayerStats = async () => {
            setPlayerData(null)
            setLoading(true)
            try {
                await fetchWithRetry(`${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/player_roster/${params.id}`, {
                    headers: {
                        "accepts": "application/json"
                    },
                    method: "GET"
                }).then(results => results.json())
                    .then(data => {
                        console.log("set data:", data);
                        setPlayerData(data);
                        setLoading(false); // Set loading to false when data is received
                    });
            } catch (err) {
                console.log('No Player Stats: ', err);
                // setPlayerData(PlayerDataInit);
                setLoading(false); // Set loading to false even in case of an error
            }
        };


        getPlayerStats();
    }, [params.id]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const renderTabContent = () => {
        switch (selectedTab) {
            case 0:
                return playerData ? <PlayerOverview playerDataOverview={playerData.overview} playerDataRanks={playerData.ranks} /> : <p>No Data Available</p>;
            case 1:
                return playerData ? (
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <EloChart data={playerData.eloChartRecords} />
                        <APNCourseChart data={playerData.courseRecords} />
                    </Box>
                ) : <p>No Data Available</p>;
            case 2:
                return playerData ? <PlayerCourses courseData={playerData.courseRecords} /> : <p>No Data Available</p>;
            default:
                return null;
        }
    };

    return (
        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            {loading ? (
                <LoadingShells />
            ) : (<>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ p: 1, mb: 1 }}>
                    <Header src={`${IMAGE_URL}headers/Stats.png`} alt="Stats Title" />
                </Box>
                <SearchBar grandPrixList={JSON.parse(localStorage.getItem("apiGrandPrixListV2"))} playerList={JSON.parse(localStorage.getItem("apiRosterV2"))}/>
                {playerData && (
                    <StatsPlayerHeader
                        characterId={playerData.character.characterId}
                        firstName={playerData.character.firstName}
                        lastName={playerData.character.lastName}
                        key={playerData.playerId}
                    />
                )}
                {/* Show 'No Stats Available' if there are no stats */}
                {!playerData || !playerData.overview ? (
                        <>
                            <StatsPlayerHeader
                                characterId="9"
                                firstName={playerInfo?.firstName || ''}
                                lastName={playerInfo?.lastName || ''}
                                key={playerInfo?.playerId || params.id}
                            />
                            <Box align='center' sx={{mt:7}}>
                                <img
                                    src={`${IMAGE_URL}char_gifs/misc/DK_8bit.gif`}
                                    alt="Loading..."
                                    style={{ width: '50%', maxWidth: '300px' }} // Adjust size as needed
                                />
                            </Box>
                            <Typography sx={{  p: 3, fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '.75rem', color: 'black' }}>
                                No Stats Available
                            </Typography>
                        </>

                    ) : (
                        <Box sx={{ marginTop: 1 }}>
                            <Tabs
                                value={selectedTab}
                                onChange={handleTabChange}
                                centered
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab label="Overview" />
                                <Tab label="Charts" />
                                <Tab label="Courses" />
                            </Tabs>
                            <Box align='center' sx={{ display: 'flex', justifyContent: 'center', width: "100vw" }}>
                                {renderTabContent()}
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </Container>
    );
};

export default StatsPlayer;
